import { Care } from '../components';

const Osteopathie = () => {
   return <Care showDetails />;
};
export default Osteopathie;
